import { attr as o } from "@microsoft/fast-element";
var f = Object.defineProperty, p = (e, t, a, v) => {
  for (var r = void 0, i = e.length - 1, n; i >= 0; i--)
    (n = e[i]) && (r = n(t, a, r) || r);
  return r && f(t, a, r), r;
};
class s {
}
p([
  o
], s.prototype, "size");
export {
  s as PaginationMixin
};
